import { DocumentCreationItemContainer } from '@/features/documents/DocumentCreationModal/DocumentCreationItem/DocumentCreationItemContainer'
import { observer } from 'mobx-react-lite'
import { type JobProgressionRequestDraftApprovalViewModel } from './JobProgressionRequestDraftApprovalViewModel'
import { JobProgressionUploadModal } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionUploadModal'

export interface JobProgressionRequestDraftApprovalModalContainerProps {
  vm: JobProgressionRequestDraftApprovalViewModel
}

export const JobProgressionRequestDraftApprovalModalContainer = observer(
  function JobProgressionRequestDraftApprovalModalContainer({
    vm,
  }: JobProgressionRequestDraftApprovalModalContainerProps) {
    const documentViewModel = vm.documentViewModel
    if (!documentViewModel) {
      return null
    }

    return (
      <JobProgressionUploadModal
        showing={documentViewModel.modal.showing}
        dragging={documentViewModel.dragging}
        title="Upload draft documents"
        description="Upload the draft return for your client to review"
        isUploadDisabled={
          vm.requestDraftApproval.pending || !vm.canRequestDraftApproval
        }
        isUploadPending={vm.requestDraftApproval.pending}
        onRequestClose={vm.close}
        onAddFiles={documentViewModel.addFiles}
        onDragEnter={documentViewModel.setDragging}
        onDragLeave={documentViewModel.stopDragging}
        onUpload={vm.requestDraftApproval}
        fileInputTestId="upload-draft-documents-file-input"
        uploadButtonTestId="upload-draft-documents-confirm-button"
      >
        {documentViewModel.documentCreationItemVms.map(
          (docCreationItemVm, index) => (
            <div key={index}>
              <DocumentCreationItemContainer
                index={index}
                vm={docCreationItemVm}
                onRemove={documentViewModel.removeFile}
              />
            </div>
          ),
        )}
      </JobProgressionUploadModal>
    )
  },
)
